import React from 'react';
import './AboutValues.css';

const VALUES = [
  {
    num: '01',
    title: 'AUTHENTICITY',
    body: 'Every pair we stock is verified. Every story we tell is real. From the stitching to the sole, if it isn’t 100% legit, it doesn’t touch our shelves.',
    tag: 'GUARANTEED HEAT'
  },
  {
    num: '02',
    title: 'COMMUNITY',
    body: 'Before we were a business, we were a group chat. That spirit—putting the people first and profit second—is the heartbeat of SA Dropped.',
    tag: 'THE 031 & BEYOND'
  },
  {
    num: '03',
    title: 'CULTURE',
    body: 'We don’t just sell sneakers. We document and amplify South African street culture, preserving the history of every drop for the next generation.',
    tag: 'ARCHIVING THE SOLE'
  },
  {
    num: '04',
    title: 'CRAFT',
    body: 'The details matter. We appreciate the construction, the materials, and the heritage behind every silhouette we curate.',
    tag: 'BEYOND THE HYPE'
  }
];

export default function AboutValues() {
  return (
    <section className="av">
      <div className="av__container">
        <div className="av__header">
          <p className="av__eyebrow">W h a t &nbsp; W e &nbsp; S t a n d &nbsp; F o r</p>
          <h2 className="av__main-title">CORE VALUES</h2>
        </div>

        <div className="av__list">
          {VALUES.map((v, i) => (
            <div key={v.num} className="av__item">
              <div className="av__num-col">
                <span className="av__num">{v.num}</span>
              </div>
              
              <div className="av__content-col">
                <div className="av__text-wrap">
                  <span className="av__tag">{v.tag}</span>
                  <h3 className="av__ch-title">{v.title}</h3>
                  <p className="av__body-text">{v.body}</p>
                </div>
                <div className="av__line-break" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}